import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPlansRequest,
  purchasePlanRequest,
  checkActivePlanRequest,
  checkButtonRequest,
} from "../../../redux/sagas/Subscription/SubscriptionSlice";
import {
  CalculationType,
  subscriptionFrequency,
} from "../../../configs/constants";
import ActiveSubscription from "./ActiveSubscription";
import {
  clearCouponError,
  clearCouponInfo,
  getApplicableCouponsRequest,
} from "../../../redux/sagas/Coupon/CouponSlice";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { canShowPermission } from "../Permissions/permissionObject";
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function SubscriptionPlans() {
  const { active_plan = [] } = useSelector(
    (state) => state.subscriptionPlan || {},
  );
  const [open, setOpen] = useState(false);
  const [upgrade_plan, setUpgradePlan] = useState(null);

  const handleClickOpen = (plan) => {
    setUpgradePlan(plan);
    setOpen(true);
  };

  const handleClose = () => {
    setUpgradePlan(null);
    setOpen(false);
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <div>
        {/* Fullscreen Modal */}
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Upgrade Your Plan
              </Typography>
              <Button autoFocus color="inherit" onClick={handleClose}>
                Cancel
              </Button>
            </Toolbar>
          </AppBar>

          {/* Modal Content */}
          <div style={{ padding: 24 }}>
            <SubscriptionsList upgrade_plan={upgrade_plan} />
          </div>
        </Dialog>
      </div>
      <Box sx={{ height: "100%", overflowY: "auto", pt: 4 }}>
        <Grid container spacing={3} justifyContent="center">
          {active_plan.map((plan) => {
            return (
              <ActiveSubscription plan={plan} onUpgrade={handleClickOpen} />
            );
          })}
        </Grid>
        <SubscriptionsList />
      </Box>
    </Box>
  );
}

const SubscriptionsList = ({ upgrade_plan }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data = [], active_plan = [] } = useSelector(
    (state) => state.subscriptionPlan || {},
  );
  const couponInfo = useSelector((state) => state.coupon.coupon_info);
  const couponError = useSelector((state) => state.coupon.error);
  const [didVerify, setDidVerify] = useState(false);
  const [openCouponModal, setOpenCouponModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [couponCode, setCouponCode] = useState("");
  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);
  const canCreate = canShowPermission(permissions, "jeweller", "create");

  const calculateAmountWithGST = (amount) => {
    return Number((Number(amount) * 1.18).toFixed(2));
  };
  let upgrade_value = upgrade_plan
    ? calculateUpgradeSubscriptionValue(upgrade_plan)
    : 0;

  const totalAmount = selectedPlan
    ? calculateAmountWithGST(selectedPlan.amount)
    : 0;
  const discountAmount =
    Object.keys(couponInfo).length > 0
      ? Number(
          couponInfo.calculationType == CalculationType.Percentage
            ? Math.round(
                (Number(selectedPlan?.amount) * Number(couponInfo.value)) / 100,
              )
            : couponInfo.value,
        )
      : 0;
  const payableAmount =totalAmount - discountAmount - upgrade_value;

  const onVerify = () => {
    if (!couponCode.trim()) return;
    setDidVerify(true); // <— mark attempt
    dispatch(getApplicableCouponsRequest(couponCode));
  };

  async function purchasePlanWithCoupon() {
    setOpenCouponModal(false);
    let payload = {
      ...selectedPlan,
      amount: calculateAmountWithGST(selectedPlan.amount),
      discountAmount: Math.round(discountAmount),
      payableAmount: Math.round(payableAmount),
      app_subscription: upgrade_plan ? upgrade_plan._id : null,
      coupon: couponInfo?.code ? couponInfo?.code : "",
    };
    dispatch(purchasePlanRequest(payload));
  }

  const handleCouponModalClose = () => {
    dispatch(clearCouponError()); // clear redux error
    dispatch(clearCouponInfo());
    setCouponCode(""); // clear input
    setOpenCouponModal(false); // close modal
  };

  const handleOpenCouponModal = (plan) => {
    dispatch(clearCouponError()); // reset Redux coupon error
    dispatch(clearCouponInfo());
    setCouponCode(""); // clear input
    setSelectedPlan(plan);
    setOpenCouponModal(true);
  };

  useEffect(() => {
    dispatch(fetchPlansRequest());
    dispatch(checkActivePlanRequest());
  }, []);

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      {/* dialog for enter coupon code */}
      <Dialog
        open={openCouponModal}
        onClose={handleCouponModalClose}
        PaperProps={{
          sx: { borderRadius: 3, padding: 2, minWidth: 450 },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", pb: 1 }}>
          Enter Coupon Code
        </DialogTitle>

        <DialogContent>
          {selectedPlan && (
            <Box
              sx={{ mb: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 2 }}
            >
              <Typography variant="subtitle1">
                Total Amount with GST (18%): ₹{Math.round(totalAmount)}
              </Typography>

              <Typography variant="subtitle1" color="success.main">
                Discount: ₹{Math.round(discountAmount)}
              </Typography>

              {upgrade_value && (
                <Typography variant="subtitle1" color="success.main">
                  Current Plan Balance: ₹{Math.round(upgrade_value)}
                </Typography>
              )}

              <Typography variant="h6" fontWeight="bold">
                Payable Amount: ₹{Math.round(payableAmount)}
              </Typography>
            </Box>
          )}

          <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Coupon code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
              />
              <Button
                variant="contained"
                color="primary"
                sx={{ height: "56px", whiteSpace: "nowrap", borderRadius: 2 }}
                onClick={onVerify}
              >
                Verify
              </Button>
            </Stack>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 1 }}>
          <Button
            variant="outlined"
            color="success"
            sx={{ height: "56px", whiteSpace: "nowrap", borderRadius: 2 }}
            //  disabled={useCoupon && !(couponInfo && couponInfo.code === couponCode)}
            onClick={purchasePlanWithCoupon}
          >
            Buy Subscription
          </Button>
        </DialogActions>
      </Dialog>
      {/* Page Heading */}
      <Typography variant="h3" align="center" gutterBottom fontWeight="bold">
        Subscription Plans
      </Typography>

      <Typography
        variant="subtitle1"
        align="center"
        color="text.secondary"
        sx={{ mb: 5 }}
      >
        Choose the plan that best suits your needs.
      </Typography>

      {/* Plans */}
      <Grid container spacing={3} justifyContent="center">
        {data.map((plan) => (
          <>
            {plan.enabled && (
              <Grid item key={plan.planName} xs={12} sm={6} md={4} lg={3}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: 6,
                    },
                  }}
                >
                  {/* Title */}
                  <CardHeader
                    title={plan.planName}
                    titleTypographyProps={{
                      align: "center",
                      fontWeight: "bold",
                      variant: "h6",
                    }}
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      py: 1.5,
                    }}
                  />

                  {/* Card Body */}
                  <CardContent sx={{ flexGrow: 1 }}>
                    {/* Price */}
                    <Typography
                      component="h2"
                      variant="h3"
                      color="text.primary"
                      align="center"
                      fontWeight="bold"
                    >
                      ₹{calculateAmountWithGST(plan.amount)}
                    </Typography>
                    <Typography
                      variant="caption"
                      align="center"
                      color="text.secondary"
                      display="block"
                    >
                      ₹{plan.amount} + 18% GST
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      align="center"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      per {displayPlanValidity(plan.validity)}
                    </Typography>

                    {/* Features */}
                    <Divider sx={{ my: 2 }} />
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                      color="primary"
                    >
                      Features
                    </Typography>
                    <List dense>
                      {plan.features.map((feature) => (
                        <ListItem key={feature} disableGutters>
                          <ListItemIcon>
                            <CheckIcon color="success" />
                          </ListItemIcon>
                          <ListItemText primary={feature} />
                        </ListItem>
                      ))}
                    </List>

                    {/* Benefits */}
                    <Divider sx={{ my: 2 }} />
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                      color="primary"
                    >
                      Benefits
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor: "rgba(25, 118, 210, 0.05)",
                        borderRadius: 2,
                        p: 1,
                      }}
                    >
                      <List dense>
                        {plan.benefits?.map((benefit) => (
                          <ListItem key={benefit.description} disableGutters>
                            <ListItemIcon>
                              <CheckIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                benefit.restricted
                                  ? `${benefit.value} ${benefit.label} `
                                  : `Unlimited ${benefit.label} `
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </CardContent>

                  {/* Button fixed at bottom */}
                  <CardActions sx={{ justifyContent: "center", p: 2 }}>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      fullWidth
                      onClick={() => {
                        if (canCreate) {
                          navigate("/JewellerSubscription", {
                            state: {
                              fromUpgrade: true,
                              planToSelect: plan,
                            },
                          });
                        } else {
                          handleOpenCouponModal(plan);
                        }
                      }}
                    >
                      {upgrade_plan ? "Upgrade" : "Subscribe"}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )}
          </>
        ))}
      </Grid>
    </Container>
  );
};

function displayPlanValidity(planValidity) {
  switch (planValidity) {
    case subscriptionFrequency.daily:
      return "Day";
    case subscriptionFrequency.weekly:
      return "Week";
    case subscriptionFrequency.biweekly:
      return "2 Weeks";
    case subscriptionFrequency.monthly:
      return "Month";
    case subscriptionFrequency.quarterly:
      return "Quarter";
    case subscriptionFrequency.half_Yearly:
      return "Half Year";
    case subscriptionFrequency.yearly:
      return "Year";
    default:
      return planValidity; // or "";
  }
}

function calculateUpgradeSubscriptionValue(plan) {
  let start_date = moment(plan.startDate);
  let end_date = moment(plan.endDate);
  const today = moment();

  const totalDays = end_date.diff(start_date, "days");
  const usedDays = today.diff(start_date, "days");
  const effectiveUsedDays = Math.min(usedDays, totalDays);
  const dailyRate = plan.amount / totalDays;
  const amountUsed = dailyRate * effectiveUsedDays;
  return plan.amount - amountUsed;
}
